module.exports = __webpack_public_path__ + "img/stock1.bb4af784.png";